import PackagesPage from '../../../packages/PackagesPage'

export default PackagesPage
